module.exports = __webpack_public_path__ + "static/img/4@2x.77198ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/4@2x.png
// module id = V763
// module chunks = 1